import { Position } from './mentionSuggestions.types';

export const PADDING = 10;
export const ITEM_HEIGHT = 42;
export const MAX_WRAPPER_WIDTH = 400;
export const ITEMS_TO_DISPLAY = 5.5;
export const MAX_LIST_HEIGHT = ITEM_HEIGHT * ITEMS_TO_DISPLAY;
// padding right is PADDING/2 to make extra space for scrollbar
export const MAX_LIST_WIDTH = MAX_WRAPPER_WIDTH - 1.5 * PADDING;
export const MIN_SPACE_TOP = 40;

export const initialPosition: Position = { left: -9999, top: -9999 };
